var map = {
	"./banner-1.jpg": 8961,
	"./banner-10.jpg": 54912,
	"./banner-11.jpg": 34487,
	"./banner-12.jpg": 40631,
	"./banner-13.jpg": 29057,
	"./banner-14.jpg": 65950,
	"./banner-15.jpg": 53530,
	"./banner-16.jpg": 74985,
	"./banner-17.jpg": 64660,
	"./banner-18.jpg": 42058,
	"./banner-19.jpg": 560,
	"./banner-2.jpg": 73413,
	"./banner-3.jpg": 98098,
	"./banner-4.jpg": 19804,
	"./banner-5.jpg": 13419,
	"./banner-6.jpg": 71635,
	"./banner-7.jpg": 96412,
	"./banner-8.jpg": 39319,
	"./banner-9.jpg": 74032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80660;